import { useSessionDraft } from '../hooks/useSessionDraft';
import { useWordStore } from '../stores/wordStore';
import './DraftBanner.css';

export default function DraftBanner() {
  const { pendingDraft, restoreDraft, discardDraft } = useSessionDraft();
  const words = useWordStore((s) => s.words);

  if (!pendingDraft) return null;

  const wordExists = words.some((w) => w.id === pendingDraft.activeWordId);
  const ts = new Date(pendingDraft.timestamp).toLocaleString();

  if (!wordExists) {
    return (
      <div className="draft-banner draft-banner-warning">
        <span>The word from your last session is no longer available.</span>
        <button className="draft-btn" onClick={discardDraft}>Dismiss</button>
      </div>
    );
  }

  return (
    <div className="draft-banner">
      <span>Restored unsaved changes from {ts}. Save to Airtable?</span>
      <div className="draft-actions">
        <button className="draft-btn draft-btn-primary" onClick={restoreDraft}>Restore</button>
        <button className="draft-btn" onClick={discardDraft}>Discard</button>
      </div>
    </div>
  );
}
